import PropTypes from 'prop-types';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import './mapNugget.scss';

const MapNugget = ({ labels, onClick }) => {
  if (!labels?.mapImage) {
    return null;
  }
  return (
    <button type="button" className="gw-hotel-map-nugget" onClick={onClick}>
      <CloudinaryPicture
        img={labels.mapImage.media}
        lazy
        retina
        sizes={[
          {
            width: 364,
            height: 245,
            breakpoint: 975,
          },
          {
            height: 287,
            width: 287,
            breakpoint: 768,
          },
          {
            height: 400,
            width: 747,
            breakpoint: 480,
          },
          {
            width: 459,
            height: 250,
          },
        ]}
        alt=""
      />
    </button>
  );
};

MapNugget.propTypes = {
  labels: PropTypes.shape({
    mapImage: PropTypes.shape({
      media: PropTypes.shape(),
    }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MapNugget;
